import { render } from "./ActionBoxes.vue?vue&type=template&id=4d3af5c6&scoped=true"
import script from "./ActionBoxes.vue?vue&type=script&lang=js"
export * from "./ActionBoxes.vue?vue&type=script&lang=js"

import "./ActionBoxes.vue?vue&type=style&index=0&id=4d3af5c6&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3af5c6"]])

export default __exports__